import { inject } from '@angular/core';
import { UserRole } from '@map/models';
import { RoleService } from '@map/services/role.service';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { upsertEntities, withEntities } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { updateState, withDevtools, withDevToolsStub } from '@angular-architects/ngrx-toolkit';
import { environment } from 'src/environments/environment';

type RoleState = {
    loading: boolean;
    loaded: boolean;
};

const initialState: RoleState = {
    loading: false,
    loaded: false,
};

export const withTreeShakableDevTools = environment.production ? withDevToolsStub : withDevtools;

export const RoleStore = signalStore(
    { providedIn: 'root' },
    withTreeShakableDevTools('roles'),
    withEntities<UserRole>(),
    withState<RoleState>(initialState),
    withMethods((store, roleService = inject(RoleService)) => ({
        getAll: rxMethod<void>(
            pipe(
                switchMap(() => {
                    if (store.entities().length > 0) return store.entities();
                    updateState(store, '[Role] Get All', { loading: true });
                    return roleService.getAll<UserRole[]>().pipe(
                        tapResponse({
                            next: (roles) => {
                                updateState(store, '[Role] Get All Success', upsertEntities(roles), {
                                    loaded: true,
                                    loading: false,
                                });
                            },
                            error: (error) => {
                                console.error('Failed to load roles', error);
                                updateState(store, '[Role] Get All Failure', { loading: false });
                            },
                        })
                    );
                })
            )
        ),
    }))
);
